export default "__VITE_ASSET__4rm9HL3z__"